import http from '../utils/http';

const sceneApi = {
    /**
     * 分页获取场景列表
     */
    getScenarioByPage(options = {}, config = {}) {
        return http.get('/scenario/getScenarioByPage', options, {
            ...config
        })
    },

    /**
     * 新增场景
     */
    addScenario(options = {}, config = {}) {
        return http.post('/scenario/addScenario', options, {
            ...config
        })
    },

    /**
     * 修改场景
     */
    updateScenario(options = {}, config = {}) {
        return http.post('/scenario/updateScenario', options, {
            ...config
        })
    },
    /**
     * 启用/禁用场景
     */
    stopStatus(options = {}, config = {}) {
        return http.post('/scenario/stopStatus', options, {
            ...config
        })
    },
    /**
     * 删除场景
     */
    deleteScenario(scenarioId='') {
        return http.delete(`/scenario/deleteScenario?scenarioId=${scenarioId}`)
    }
}

export default sceneApi;
